// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isCdiJobSyncStatusSummaryResult = objectOf({
  SUCCESS: number,
  RUNNING: number,
  PARTIAL: number,
  ERROR: number,
  LIMIT_EXCEEDED: number,
});
